import React from 'react';
import {
  MantineProvider, MantineThemeOverride, AppShell, Paper,
} from '@mantine/core';
import { useBooleanToggle } from '@mantine/hooks';
import './App.css';
import {
  createBrowserRouter,
  RouterProvider,
  Outlet,
} from 'react-router-dom';
import HeaderResponsive from './components/HeaderResponsive';
import FooterResponsive from './components/FooterResponsive';
import NavbarNested from './components/NavBarNested/NavBarNested';
import Resume from './pages/Resume';
import { LANGUAGES } from './config/constants';
import Portfolio from './pages/Portfolio';

const myTheme: MantineThemeOverride = {
  colorScheme: 'light',
  primaryColor: 'yellow',
  defaultRadius: '0.4rem',
};

function AppLayout() {
  const [navbarOpened, setNavbarOpened] = useBooleanToggle(false);

  return (
    <MantineProvider theme={myTheme} withGlobalStyles withNormalizeCSS>
      <AppShell
        padding={0}
        navbarOffsetBreakpoint="lg"
        navbar={(
          <NavbarNested hidden={!navbarOpened} toggleNavbarOpened={setNavbarOpened} />
        )}
        header={(
          <HeaderResponsive
            languages={LANGUAGES}
            navbarOpened={navbarOpened}
            setNavbarOpened={setNavbarOpened}
          />
        )}
        styles={() => ({
          // main: { backgroundColor: theme.colorScheme === 'dark'
          // ? theme.colors.dark[8]
          // : theme.colors.gray[0] },
        })}
      >
        <div className="App">
          <Paper shadow="xs" p="md" className="App-paper center">
            <Outlet />
            <FooterResponsive />
          </Paper>
        </div>
      </AppShell>
    </MantineProvider>
  );
}

function App() {
  const router = createBrowserRouter([
    {
      element: <AppLayout />,
      children: [
        {
          path: '/:lang?/',
          element: <Resume />,
        },
        {
          path: '/',
          element: <Resume />,
        },
        {
          path: '/portfolio',
          element: <Portfolio />,
        },
      ],
    },
  ]);

  return (
    <RouterProvider router={router} />
  );
}

export default App;
